var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSVG)?_c('div',{staticClass:"app-icon font-icon"},[_c('i',{staticClass:"material-icons",style:({
      'font-size': _vm.fontSize,
      color: _vm.color,
    })},[_vm._t("default")],2)]):_c('div',{staticClass:"app-icon svg",style:({
    width: _vm.width,
    height: _vm.height,
    color: _vm.color,
    'background-color': _vm.backgroundColor,
  })},[(_vm.src)?_c('div',{staticClass:"mask",style:({
      'mask-image': `url('${_vm.src}')`,
    })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }